<template>
  <div class="col-avatar">
    <img :src="avatarSrc" class="col-avatar-img">
    <label for="input-avatar" class="col-avatar-btn v-btn theme--light">
      ファイルを選択
    </label>
    <input type="file" name="input_avatar" class="col-avatar-input" id="input-avatar" @change="showPreview($event)">
    <input type="hidden" name="avatar_base64" v-model="trimmedFile">
    <canvas class="avatar-canvas" ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  props: [
    'avatar'
  ],

  data () {
    return {
      avatarSrc: this.avatar,
      imageData: null,
      trimmedFile: null
    }
  },

  methods: {
    showPreview (e) {
      const files = e.target.files

      if (files.length < 1) {
        return false
      }

      const file = files[0]

      const reader = new FileReader()

      reader.onload = (e) => {
        this.avatarSrc = e.target.result

        const image = new Image()
        image.src = this.avatarSrc

        image.onload = () => {
          const width = 100
          const ratio = 100 / image.width
          const height = image.height * ratio

          this.$refs.canvas.width = width
          this.$refs.canvas.height = height

          const ctx = this.$refs.canvas.getContext('2d')
          ctx.drawImage(image, 0, 0, width, height)
          this.trimmedFile = this.$refs.canvas.toDataURL('image/png')
        }
      }

      reader.readAsDataURL(file)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../sass/variables';

  .avatar-canvas {
    display: none;
  }
</style>
